export const FIELD_OF_STUDY_LIST_REQUEST = "FIELD_OF_STUDY_LIST_REQUEST"
export const FIELD_OF_STUDY_LIST_SUCCESS = "FIELD_OF_STUDY_LIST_SUCCESS"
export const FIELD_OF_STUDY_LIST_FAIL = "FIELD_OF_STUDY_LIST_FAIL"

